import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  return Yup.object({
    _sublineId: Yup.number().required(requiredMessage),
    sublineItemId: Yup.number(),
    sublineCorpid: Yup.string().nullable(),
    chargeCode: Yup.string().max(4, "Max length allowed is 4.").nullable(),
    chargePercent: Yup.string().max(30, "Max length allowed is 30.").nullable(),
    chargeCost: Yup.string().max(30, "Max length allowed is 30.").nullable(),
    chargeUom: Yup.string().max(2, "Max length allowed is 2.").nullable(),
    chargeQuantity: Yup.number(),
    chargeMethodDesc: Yup.string().max(80, "Max length allowed is 80.").nullable(),
  })
}

export default makeValidationSchema
